module.exports = __webpack_public_path__ + "img/dn2me_icon.4b9b7dae.svg";